import { groupBy } from "lodash";
import React, { lazy, Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate, Route, Routes } from "react-router-dom";
import { config } from "./configs/manifest";

const { AppConfig, HeaderConfig, FooterConfig, LayoutConfig, RouteConfig, PageConfig }: any =
  config;

const routesGroupByLayout = groupBy(RouteConfig, (route) => route.layout);

const DefaultPage = lazy(() => import(`./pages/Default`));

const App = () => {
  const routers = Object.keys(routesGroupByLayout).map((key: string, index: number) => {
    const routes = routesGroupByLayout[key];
    const layout = LayoutConfig[key];
    const header = { ...HeaderConfig, ...(layout?.header ?? {}) };
    const footer = { ...FooterConfig, ...(layout?.footer ?? {}) };
    const appConfig = { ...AppConfig, ...(layout?.appConfig ?? {}) };
    const props = { header, footer, appConfig, layout };

    return (
      <Route key={`route-${key}`} element={<layout.component {...props} />}>
        {routes.map((route) => {
          const { component: Component = DefaultPage, ...props }: any = PageConfig[route.page] ?? {
            path: route.path,
          };
          return <Route key={route.path} path={route.path} element={<Component {...props} />} />;
        })}
      </Route>
    );
  });

  return (
    <ErrorBoundary fallback={<div>Something went wrong, try refreshing the page.</div>}>
      <Suspense fallback={<div>Loading..</div>}>
        <Routes>
          {routers}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
};

export default App;
